export const homepageFeatures = [
    { icon: 'bi bi-braces-asterisk', translationKey: 'systems' },
    { icon: 'bi bi-trophy', translationKey: 'formats' },
    { icon: 'bi bi-shuffle', translationKey: 'pairing' },
    { icon: 'bi bi-graph-up', translationKey: 'ratings' },
    { icon: 'bi bi-bar-chart-line', translationKey: 'seasons' },
    { icon: 'bi bi-journal-richtext', translationKey: 'history' },
    { icon: 'bi bi-phone', translationKey: 'mobile' },
  ];

export const homepageMap = {
  mapPins: [
    { label: 'New York', value: 2, left: '10%', top: '32%' },
    { label: 'London', value: 8, left: '33%', top: '26%' },
    { label: 'Tbilisi', value: 9, left: '40%', top: '32%' },
    { label: 'Dubai', value: 3, left: '49%', top: '47%' },
    { label: 'Mumbai', value: 5, left: '61%', top: '55%' },
    { label: 'Bangkok', value: 4, left: '68%', top: '58%' },
    { label: 'Tokyo', value: 5, left: '77%', top: '36%' },
    { label: 'Rio', value: 5, left: '24%', top: '70%' },
    { label: 'Cape Town', value: 3, left: '43%', top: '78%' },
  ],

  cities: [
    { translationKey: 'batumi', clubs: 1, tournaments: 46 },
    { translationKey: 'poznan', clubs: 1, tournaments: 2 },
  ],
};
